export type LinkModel = {
	rel?: string;
	href: string;
	hreflang?: string;
	media?: string;
	title?: string;
	type?: string;
	deprecation?: string;
	profile?: string;
	name?: string;
};

export type SubscriptionLinksResponse = {
	'bulletin-souscription': LinkModel;
	'attestation-souscription': LinkModel;
	'attestation-propriete': LinkModel;
	'attestation-dissolution': LinkModel;
	'facture-frais-investisseurs': LinkModel;
	'procuration-oca': LinkModel;
	packPEA: LinkModel;
};

export type SubscriptionLinksModel = {
	subscriptionForm: LinkModel;
	subscriptionCertificate: LinkModel;
	propertyCertificate: LinkModel;
	dissolutionCertificate: LinkModel;
	investorsFeesInvoice: LinkModel;
	packPEA: LinkModel;
	procurationOca: LinkModel;
};

export const translateSubscriptionLinksResponse = (
	l: SubscriptionLinksResponse
): SubscriptionLinksModel => {
	return {
		subscriptionForm: l['bulletin-souscription'],
		subscriptionCertificate: l['attestation-souscription'],
		propertyCertificate: l['attestation-propriete'],
		dissolutionCertificate: l['attestation-dissolution'],
		investorsFeesInvoice: l['facture-frais-investisseurs'],
		packPEA: l['packPEA'],
		procurationOca: l['procuration-oca']
	};
};
